import baustein from "baustein";
import { openOverlay } from "web/redux/ducks/cookie-settings";
import store from "web/redux/store";

export default baustein.register("cookie-settings", {
    setupEvents: function (add) {
        add("click", this.onClick);
    },

    onClick() {
        store.dispatch(openOverlay());
    },
});
